import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';

import * as faker from 'faker';

import {
  MatSnackBar,
  MatSnackBarConfig,
} from '@angular/material/snack-bar';

import {
  ScopesChecker,
} from '@nymos/auth';
import { Store } from '@ngxs/store';
import { CheckAgentWalletForKycApproval, CheckTravelCardIssuanceForKycApproval, GetAgentListForKycApproval, UserKycApproval } from '../../../core/store/accounts-agent-kyc/accounts-agent-kyc.actions';
import { state } from '@angular/animations';
import { Observable,Subject, BehaviorSubject, Subscription } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { AccountsAgentKycState } from '../../../core/store/accounts-agent-kyc/accounts-agent-kyc.state';
import { AgentAccount } from '@michel.freiha/ng-sdk';
import { AccountProfile } from '../../../core/core';
import { FormControl } from '@angular/forms';
import { UserAccountVerificationStatus } from '@michel.freiha/ng-sdk';
import { MatSpinner } from '@angular/material'; 

@Component({
  selector: 'nym-kyc-2',
  templateUrl: './kyc-2.component.html',
  styleUrls: ['./kyc-2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class KYC2Component implements OnInit, OnChanges, OnDestroy {

  @HostBinding('class.nym-kyc-2')
  protected get classes(): boolean { return true; }

  @Output()
  protected next: EventEmitter<string> = new EventEmitter();
  protected agents$: Observable<AccountProfile[]>;
  protected _onDestroy = new Subject<void>();
  protected walletState$: Observable<boolean>;
  protected lastCardIdState$: Observable<boolean>;
  protected cardState$: Observable<boolean>;
  protected approveKycState$: Observable<boolean>;
  @Input()
  public account: any;

  @Input()
  public approvalStatus: any;
  public agentId: any;
  public agents: any;
  public filteredAgents: any;
  public walletState: boolean;
  public cardState: any;
  public approveKycState: any;
  public disableToggle: boolean;
  public searchAgent: FormControl = new FormControl('');
  public transactionId: any;
  public secondUUID: any;
  public verificationStatus$: Subject<any>;
  public verificationStatus: any;
  private kycDone:boolean;
  private greyOut:boolean;

  private s1: Subscription = new Subscription();
  private s2: Subscription = new Subscription();
  private s3: Subscription = new Subscription();
  private s4: Subscription = new Subscription();
  private s5: Subscription = new Subscription();
  private s6: Subscription = new Subscription();

  constructor(
    private _store: Store,
    private _snackbar: MatSnackBar
  ) { 
  this.verificationStatus$ = new BehaviorSubject('');
  this.kycDone=false;
  this.greyOut=false;
  this.transactionId = faker.random.uuid();
  this.secondUUID = faker.random.uuid();
}

  public ngOnInit(): void {
    this.disableToggle = true;

    this.verificationStatus$.subscribe((verificationStatus) => {
      this.verificationStatus = verificationStatus;
    })
     //this.searchAgent.patchValue(this.account.kyc2Agent);
      this.filterAgents();
   }

   public agentSelected(event: any): void {
  
     let accountId = event.value.accountId;
     this.agentId = accountId;
     let userId = this.account.id;

     this._store.dispatch(new CheckAgentWalletForKycApproval(accountId,userId, accountId, this.transactionId,this.secondUUID, true)).subscribe((checkWallet)=>{
        this._store.dispatch(new CheckTravelCardIssuanceForKycApproval(userId, userId, this.secondUUID, true)).subscribe((cardCheck)=>{
        this.greyOut=true;
        this.walletState$ = this._store.select(AccountsAgentKycState.walletState);
        this.s1=this.walletState$.subscribe((walletState) => {
        this.walletState = walletState;
          if (this.walletState) {
             this.cardState$ = this._store.select(AccountsAgentKycState.cardState);
             this.s2=this.cardState$.subscribe((disableToggle) => {
             this.disableToggle = !disableToggle;
              if(this.greyOut)
                this.greyOut=false;
                this.s1.unsubscribe();
                this.s2.unsubscribe();
            });
          }
       else
         if (this.walletState=== false) 
        {
            this.greyOut=false;
            this.s1.unsubscribe();
            this.s2.unsubscribe();
       }
         });
        });
     });
  
   }

   public approvekyc(event: any): void {
     this.kycDone=true;
     this.greyOut=true;
     let userId = this.account.id;
     this._store.dispatch(new UserKycApproval(userId, this.agentId));
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.verificationStatus$.next(this.account.verificationStatus);
  }

   public disableField(): boolean {
    return this.verificationStatus === UserAccountVerificationStatus.Kyc2Approved; 
  }

  protected filterAgents():void {

    this.resolveAgents(this.searchAgent.value);

    // if (!this.agents) {
    //   return;
    // }
    // // get the search keyword
    // let search = this.searchAgent.value;

    // if (!search && !this.agents) {
    //   this.agents= JSON.stringify(JSON.parse(this.agents));
    //   return;
    // } else {
    //   search = search.toLowerCase();
    // }
    // filter the banks

      //this.filteredAgents= this.agents.filter(ag => (ag.fullName+ag.mobile).toLowerCase().indexOf(search) > -1);
     //  this.filteredAgents= this.agents;

  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  public resolveAgents(searchString):void {

    this._store.dispatch(new GetAgentListForKycApproval(state,searchString));
    this.agents$ = this._store.select(AccountsAgentKycState.agents);

    this.agents$.subscribe((data: any) => {
      //this.agents = data.agents;
       this.filteredAgents= data.agents;
    });
  }



}
